<div id="rrhh-team-members-form-container">
  <h2>Agregar agentes</h2>

  <!-- TABLA: MIEMBROS DEL TEAM -->
  <div class="table-container">
    <!-- TABLE HEADER -->
    <div class="table-header">
      <div class="row">
        <div class="name">Agente</div>
        <div class="start-date">Fecha de alta</div>
        <div class="end-date">Fecha de baja</div>
        <div class="action"></div>
      </div>
    </div>
    <!-- TABLE BODY -->
    <div class="table-body">
      <!-- ROW -->
      <div
        class="row"
        *ngFor="let m of membersList; let i = index"
        [ngClass]="{
          leader: m.leader,
          'hide-row': animationOutIndex == i,
          'show-row': animationInRow.includes(i),
          inactive: m.endDate
        }"
      >
        <!-- NOMBRE + -->
        <div class="name">
          <span class="fullname">{{ m.name }} {{ m.lastname }}</span>
          <div class="badge" *ngIf="m.leader">
            <qr-icon name="leader" color="primary-300"></qr-icon>
            <span>Team leader</span>
          </div>
          <qr-icon
            class="inactive-icon"
            name="info"
            color="error-700"
            matTooltip="No pertenece al team"
            *ngIf="m.endDate"
          ></qr-icon>
          <qr-chip
            [config]="chipHierarchy2"
            *ngIf="m.isNew && isEdit"
            value="Nuevo"
          ></qr-chip>
        </div>
        <!-- FECHA INGRESO AL TEAM -->
        <div class="start-date">
          {{ formatDate(m.startDate ? m.startDate : todayDate) }}
        </div>
        <!-- FECHA BAJA DEL TEAM -->
        <div class="end-date">{{ formatDate(m.endDate ? m.endDate : "") }}</div>
        <!-- ACCIÓN -->
        <div class="action">
          <qr-button
            *ngIf="!m.endDate && m.isNew"
            [config]="buttonIconDelete"
            [isDisabled]="m.leader"
            [ngClass]="{ 'disabled-button': m.leader }"
            (click)="onRemoveMember(m.id, i)"
            matTooltip="Eliminar"
          ></qr-button>
          <qr-button
            *ngIf="m.endDate && !m.isNew"
            [config]="buttonIconReactivate"
            [isDisabled]="m.leader"
            [ngClass]="{ 'disabled-button': m.leader }"
            (click)="reactivateMember(i)"
            matTooltip="Reactivar"
          ></qr-button>
          <qr-button
            *ngIf="!m.endDate && !m.isNew"
            [config]="buttonIconInactivate"
            [isDisabled]="m.leader"
            [ngClass]="{ 'disabled-button': m.leader }"
            (click)="onRemoveMember(m.id, i)"
            matTooltip="Inactivar"
          ></qr-button>
          <!-- EDITAR FECHA DE ALTA DEL AGENTE -->
          <qr-button
            *ngIf="!m.isNew && !m.endDate"
            class="edit"
            [config]="buttonEditDate"
            (click)="onEditDate(m.id, m.name, m.lastname, m.startDate)"
            matTooltip="Editar fecha de alta"
          ></qr-button>
        </div>
      </div>
    </div>
  </div>
  <!-- VACÍO: SIN MIEMBROS EN EL TEAM -->
  <div class="empty-table" *ngIf="showEmptyTableMembers">
    <img src="/assets/images/team_illustration.png" alt="" />
    <p>Seleccione y agregue agentes para que sean parte de su Team.</p>
  </div>

  <!-- ******************************************************** -->
  <div class="line"></div>

  <div class="top-block">
    <h2>Agregar nuevo agente</h2>
    <div class="search-box">
      <qr-input
        [config]="inputSearch"
        (valueChange)="inputSearchChange($event)"
        [value]="this.inputSearchValue"
      ></qr-input>
    </div>
  </div>
  <!-- TABLA: LISTA DE AGENTES DE LA OFICINA -->
  <div class="table-agent-list">
    <!-- TABLE HEADER -->
    <div class="table-header">
      <div class="row">
        <div class="name">Agente</div>
      </div>
    </div>
    <!-- TABLE BODY -->
    <div class="table-body">
      <!-- ROW: TODOS -->
      <div class="row">
        <ng-container *ngIf="agentList.length > 0">
          <div class="left">
            <div class="checkbox-container">
              <mat-checkbox
                [checked]="checkAll"
                color="primary"
                (change)="onCheckAll($event.checked)"
              >
              </mat-checkbox>
            </div>
            Todos
          </div>
          <div class="right">
            <qr-button
              [config]="buttonAddAgent"
              (click)="onAddAgents()"
              [isDisabled]="btnAddAgentsIsDisabled"
              matTooltip="Agregar agentes seleccionados"
            ></qr-button>
          </div>
        </ng-container>
        <!-- VACÍO: SIN AGENTES SIN TEAM -->
        <div class="empty-agents" *ngIf="agentList.length == 0">
          Ningún agente sin team
        </div>
      </div>

      <!-- ROW: AGENTES -->
      <div class="row" *ngFor="let item of agentList; let i = index">
        <div class="left">
          <div class="checkbox-container">
            <mat-checkbox
              [checked]="item.selected"
              color="primary"
              (change)="checkboxAgentsChange($event.checked, i)"
            >
            </mat-checkbox>
          </div>
          {{ item.agent.name }} {{ item.agent.lastname }}
        </div>
        <div class="right">
          <qr-button
            [config]="buttonIconAddAgent"
            (click)="onAddOneAgent(item.agent.id)"
            matTooltip="Agregar agente"
          ></qr-button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- DIALOGO CONFIRMAR: REACTIVAR MIEMBRO -->
<qr-dialog
  [config]="dialogConfirmReactivate"
  (dialogChange)="dialogReactivateMemberChange()"
></qr-dialog>

<qr-dialog [config]="dialog" (dialogChange)="dialogChange($event)"></qr-dialog>
